import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Panel } from "./routes/Panel";

/**
 * The control panel (ADR 0021 decisions 3, 6 and 7; issue #301).
 *
 * **#300 built the host and this makes it a panel.** What was here before was the smallest
 * bundle that made the edge verifiable — a real page at a real deep link, under the real CSP,
 * with the SDK initialising on the origin Stytch authorizes. That page said what this would
 * be; this is it: the session already in the browser, the families it belongs to, the switcher
 * that puts one of them in the URL, and the way out.
 *
 * **There is still no sign-in here** (`src/stytch.ts`), and there are still no screens: #302,
 * #303, #304 and #310 replace the four placeholders, and #116 replaces the fifth.
 *
 * One `<ErrorBoundary>` over the router, so any route's failure lands on the generic card
 * rather than a blank page — the login app's shape, and its reasons.
 */
export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Panel />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
